module.exports = __webpack_public_path__ + "static/media/additional_income.60ae4635.svg";